import React, { useMemo } from 'react';
import block from 'bem-cn';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

// import { providerNames } from 'modules/Casino/utils/providerNames';

// import SlotProviderIcon from 'components/Icons/SlotProviderIcon';
// import { ISlotProviderName } from 'components/Icons/SlotProviderIcon/types';
// import CheckBox from 'components/CheckBox/mobile';

import InputDate from 'components/InputDate/InputDate';
import Button from 'components/Button';
import Select from 'components/Selectors/Select';
import Input from 'components/Input';
// import Modal from 'components/Modal/mobile';
// import Input from 'components/Inputs/Input/mobile';
// import InputNumber from 'components/Inputs/InputNumber/view/mobile';

// import { ISlotsHistoryFilterProps } from './types';
import './SlotsHistoryFilter.scss';

const b = block('slots-bet-history-filter-mobile');

const SlotsHistoryFilter = ({ filterState, onClose, warning }) => {
  const dispatch = useDispatch();

  const localeCommon = useSelector(state => state.locale.locale, shallowEqual);

  /* const typeCheckboxes = useMemo(() => {
    return filterState.values.gameTypes.map(gt => (
      <label key={gt.value} className={b('check-box-container')}>
        <div className={b('check-box')}>
          <CheckBox
            checked={gt.active}
            name={gt.value}
            onChange={() => {
              const currentItem = filterState.values.gameTypes.find(gt2 => gt2.value === gt.value);
              if (currentItem) currentItem.active = !currentItem.active;
              filterState.onChangeGameType([...filterState.values.gameTypes]);
            }}
          />
        </div>
        <span className={b('check-box-text')}>{locale[gt.name as keyof typeof locale]}</span>
      </label>
    ));
  }, [filterState, locale]); */

  /* const statusCheckboxes = useMemo(() => {
    return filterState.values.statuses.map(s => (
      <label key={s.value} className={b('check-box-container')}>
        <div className={b('check-box')}>
          <CheckBox
            checked={s.active}
            name={s.name}
            onChange={() => {
              const currentItem = filterState.values.statuses.find(s2 => s2.value === s.value);
              if (currentItem) currentItem.active = !currentItem.active;
              filterState.onChangeStatus([...filterState.values.statuses]);
            }}
          />
        </div>
        <span className={b('check-box-text')}>{locale[s.name as keyof typeof locale]}</span>
      </label>
    ));
  }, [filterState, locale]); */

  const providerSelector = useMemo(() => {
    const items = filterState.values.providers.map(p => ({
      ...p,
      renderElement: (
        <div className={b('selector-item')} key={p.key}>
          <span className={b('selector-item-text')}>{p.key === 'all' ? localeCommon.all : p.key}</span>
        </div>
      ),
      selectedRenderElement: (
        <div className={b('selector-item')} key={p.key}>
          <span className={b('selector-item-text')}>{p.key === 'all' ? localeCommon.all : p.key}</span>
        </div>
      ),
    }));

    return <Select items={items} onChange={filterState.onChangeProvider} />;
  }, [filterState, localeCommon]);

  const statusSelector = useMemo(() => {
    const items = filterState.values.statuses.map(s => ({
      ...s,
      renderElement: (
        <div className={b('selector-item')} key={s.key}>
          <span className={b('selector-item-text')}>{s.key === 'all' ? localeCommon.all : s.key}</span>
        </div>
      ),
      selectedRenderElement: (
        <div className={b('selector-item')} key={s.key}>
          <span className={b('selector-item-text')}>{s.key === 'all' ? localeCommon.all : s.key}</span>
        </div>
      ),
    }));
    return <Select items={items} onChange={filterState.onChangeStatus} />;
  }, [filterState]);

  return (
    <form className={b()} onSubmit={filterState.onSubmit}>
      <div className={b('items')}>
        <div className={b('item2')}>
          <span className={b('item2-label')}>
            {localeCommon.userId}
            <span className={b('item2-label-required')}>*</span>
          </span>
          <span className={b('item2-label')}>{localeCommon.type}</span>
          <div className={b('item2-input', { withWarning: true })}>
            <Input
              value={filterState.values.userId}
              onChange={v => filterState.onChangeUserId(v.target.value)}
              name="amount"
              placeholder={localeCommon.userId}
              type="number"
              warning={warning && !filterState.values.userId && localeCommon.userIDWarning}
            />
          </div>
          <div className={b('item2-input')}>{statusSelector}</div>
        </div>

        {/* <div className={b('item-check-boxes2')}>
          <span className={b('item-check-boxes-label')}>{locale.show}</span>
          <div className={b('item-check-boxes-list')}>{statusCheckboxes}</div>
        </div> */}

        <label className={b('item-selector')}>
          <span className={b('item-selector-label')}>{localeCommon.provider}</span>
          <div className={b('item-selector-input')}>{providerSelector}</div>
        </label>

        <div className={b('item-dates-container')}>
          <div className={b('item-dates-container-item')}>
            <span className={b('item-dates-label')}>{localeCommon.from}</span>
            <div className={b('item-dates-input')}>
              <InputDate
                dateFormat="DD.MM.YYYY HH:mm"
                value={filterState.values.from}
                onChange={filterState.onChangeFrom}
                withTime={true}
              />
            </div>
          </div>
          <div className={b('item-dates-container-item')}>
            <span className={b('item-dates-label')}>{localeCommon.to}</span>
            <div className={b('item-dates-input')}>
              <InputDate
                dateFormat="DD.MM.YYYY HH:mm"
                value={filterState.values.to}
                onChange={filterState.onChangeTo}
                withTime={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={b('button')}>
        <Button type="submit">{localeCommon.show}</Button>
      </div>
    </form>
  );
};

export default SlotsHistoryFilter;
